export const WIRE_FRAGMENT = `
  fragment WireFragment on Wire {
    id
    money {
      currencyCode
      amount
    }
    to {
      name {
        firstName
        lastName
      }
      businessName
      address {
        line1
        line2
        city
        region
        postalCode
        country
      }
      beneficiaryRoutingNumber
      beneficiaryAccountNumber
      intermediaryRoutingNumber
    }
    reference
    isSubmitted
    status
    accountAlias
  }
`
